import { lazy, Suspense, type ComponentProps } from 'react';

// ActionDialog (el modal de acciones de reserva + sus 8 sub-diálogos por tipo de
// reserva, ~357KB) se cargaba EAGER en el index que bajan TODAS las rutas, porque
// lo importa el Navbar (siempre renderizado) y se comparte entre muchas rutas
// lazy. Lazy-load → su propio chunk, cargado on-demand recién al abrir el modal.
// Misma API (props passthrough). Hereda skew + SW + ErrorBoundary como cualquier
// import dinámico. fallback=null: es un modal, no se muestra un spinner antes.
const loadActionDialog = () => import('./ActionDialog');
const ActionDialogImpl = lazy(() => loadActionDialog().then((module) => ({ default: module.ActionDialog })));

/** Baja el chunk del detalle antes del clic (intención: hover, toque, foco). */
export const preloadActionDialog = (): void => {
  loadActionDialog().catch(() => {});
};

export const ActionDialog = (props: ComponentProps<typeof ActionDialogImpl>) => (
  <Suspense fallback={null}>
    <ActionDialogImpl {...props} />
  </Suspense>
);
